// extracted by mini-css-extract-plugin
export default {"registerContainer":"Register_registerContainer__T9qoo","registerForm":"Register_registerForm__j5aN8"};